module.exports = __webpack_public_path__ + "static/image3-cb13ec1104eee7317c0ec560a0f93b6e.jpg";